export default __webpack_public_path__ + "static/media/avatar.e9dc0f02.png";